import * as T from './categoryTagId';

// 헤더의 카테고리 패널에 넣을 것들
export const categoryPanelTagList = {
	언어: T.languageTags,
	영어: T.englishTags,
	미술: T.artTags,
	음악: T.musicTags,
	과학: T.scienceTags,
	역사: T.historyTags,
	안전: T.safeTags,
	리쿠행사: T.likuFestivalTags,
};

export const seniorCategoryPanelTagList = {
	치매예방인지: T.dementiaTags,
	건강지킴신체: T.bodyTags,
	마음힐링정서: T.emotionTags,
	지식쌓기교양: T.mindTags,
};

export const seoulCategoryPanelTagList = {
	구연동화: T.seoulStorytellingTags,
	'7대안전교육': T.seoulSafetyTags,
	교육: T.seoulEduTags,
};
